{
  "Act-Trades-Quick-Search-Fields": [
    {
      "label": "Symbol", "columnname": "Symbol", "placeholder": "Symbol",
      "width": "", "datatype": "String", "isLarge": false
    },
    {
        "label": "Order ID", "columnname": "orderID", "placeholder": "Order ID",
        "width": "", "datatype": "String", "isLarge": true
    },
    {
        "label": "Trade ID", "columnname": "tradeID", "placeholder": "Trade ID",
        "width": "", "datatype": "String", "isLarge": true
    }
  ],
  "Act-Trades-Grid-Columns": [
    {
      "display": "false",
      "ui_columnname": "Client Data Header Id",
      "db_columnname": "ClientDataHeaderID",
      "datatype": "String",
      "mappingkey": "clientDataHeaderID",
      "dropdown": "NO",
      "isdefault":  "false",
      "disabled": "false",
      "value": "",
      "dropdowntype": "singleselect",
      "dropdownvalue": ""
    },
    {
      "display": "true",
      "ui_columnname": "Firm MPID",
      "db_columnname": "FirmMPID",
      "datatype": "String",
      "mappingkey": "mpid",
      "dropdown": "NO",
      "isdefault":  "false",
      "disabled": "false",
      "value": "",
      "maxlength": 7,
      "dropdowntype": "singleselect",
      "dropdownvalue": ""
    },
    {
      "display": "true",
      "ui_columnname": "Trade ID",
      "db_columnname": "TradeID",
      "datatype": "String",
      "mappingkey": "tradeID",
      "dropdown": "NO",
      "isdefault":  "false",
      "disabled": "false",
      "value": "",
      "maxlength": 64,
      "dropdowntype": "singleselect",
      "dropdownvalue": ""
    },
    {
      "display": "true",
      "ui_columnname": "Order ID",
      "db_columnname": "OrderID",
      "datatype": "String",
      "mappingkey": "orderID",
      "dropdown": "NO",
      "isdefault":  "false",
      "disabled": "false",
      "value": "",
      "maxlength": 64,
      "dropdowntype": "singleselect",
      "dropdownvalue": ""
    },
    {
      "display": "true",
      "ui_columnname": "Trader Account",
      "db_columnname": "TraderAccount",
      "datatype": "String",
      "mappingkey": "traderAccount",
      "dropdown": "NO",
      "isdefault":  "false",
      "disabled": "false",
      "value": "",
      "maxlength": 30,
      "dropdowntype": "singleselect",
      "dropdownvalue": ""
    },
    {
      "display": "true",
      "ui_columnname": "Order Desk",
      "db_columnname": "OrderDesk",
      "datatype": "String",
      "mappingkey": "orderDesk",
      "dropdown": "NO",
      "isdefault":  "false",
      "disabled": "false",
      "value": "",
      "maxlength": 10,
      "dropdowntype": "singleselect",
      "dropdownvalue": ""
    },
    {
      "display": "true",
      "ui_columnname": "Symbol",
      "db_columnname": "Symbol",
      "datatype": "String",
      "mappingkey": "symbol",
      "dropdown": "NO",
      "isdefault":  "false",
      "disabled": "false",
      "value": "",
      "maxlength": 32,
      "dropdowntype": "singleselect",
      "dropdownvalue": ""
    },
    {
      "display": "true",
      "ui_columnname": "BuySellCode",
      "db_columnname": "BuySellCode",
      "datatype": "String",
      "mappingkey": "buySellCode",
      "dropdown": "NO",
      "isdefault":  "false",
      "disabled": "false",
      "value": "",
      "maxlength": 3,
      "dropdowntype": "singleselect",
      "dropdownvalue": ""
    },
    {
      "display": "true",
      "ui_columnname": "Quantity",
      "db_columnname": "Quantity",
      "datatype": "Float",
      "mappingkey": "quantity",
      "dropdown": "NO",
      "isdefault":  "false",
      "disabled": "false",
      "value": "",
      "precision": 18,
      "scale": 6,
      "dropdowntype": "singleselect",
      "dropdownvalue": ""
    },
    {
      "display": "true",
      "ui_columnname": "Price",
      "db_columnname": "Price",
      "datatype": "Float",
      "mappingkey": "limitPrice",
      "dropdown": "NO",
      "isdefault":  "false",
      "disabled": "false",
      "value": "",
      "precision": 15,
      "scale": 6,
      "dropdowntype": "singleselect",
      "dropdownvalue": ""
    },
    {
      "display": "true",
      "ui_columnname": "SystemDateTime",
      "db_columnname": "SystemDateTime",
      "datatype": "String",
      "mappingkey": "systemDateTime",
      "dropdown": "NO",
      "isdefault":  "false",
      "disabled": "false",
      "value": "",
      "dropdowntype": "singleselect",
      "dropdownvalue": ""
    },
    {
      "display": "true",
      "ui_columnname": "TradeDate",
      "db_columnname": "TradeDate",
      "datatype": "String",
      "mappingkey": "tradeDate",
      "dropdown": "NO",
      "isdefault":  "false",
      "disabled": "false",
      "value": "",
      "dropdowntype": "singleselect",
      "dropdownvalue": ""
    },
    {
      "display": "true",
      "ui_columnname": "TradeTime",
      "db_columnname": "TradeTime",
      "datatype": "String",
      "mappingkey": "tradeTime",
      "dropdown": "NO",
      "isdefault":  "false",
      "disabled": "false",
      "value": "",
      "dropdowntype": "singleselect",
      "dropdownvalue": ""
    },
    {
      "display": "true",
      "ui_columnname": "SettlementDays",
      "db_columnname": "SettlementDays",
      "datatype": "String",
      "mappingkey": "settlementDays",
      "dropdown": "NO",
      "isdefault":  "false",
      "disabled": "false",
      "value": "",
      "maxlength": 2,
      "dropdowntype": "singleselect",
      "dropdownvalue": ""
    },
    {
      "display": "true",
      "ui_columnname": "AsOfIndicator",
      "db_columnname": "AsOfIndicator",
      "datatype": "String",
      "mappingkey": "asOfIndicator",
      "dropdown": "NO",
      "isdefault":  "false",
      "disabled": "false",
      "value": "",
      "maxlength": 1,
      "dropdowntype": "singleselect",
      "dropdownvalue": ""
    },
    {
      "display": "true",
      "ui_columnname": "Execution Venue",
      "db_columnname": "ExecutionVenue",
      "datatype": "String",
      "mappingkey": "executionVenue",
      "dropdown": "NO",
      "isdefault":  "false",
      "disabled": "false",
      "value": "",
      "maxlength": 10,
      "dropdowntype": "singleselect",
      "dropdownvalue": ""
    },
    {
      "display": "true",
      "ui_columnname": "Capacity",
      "db_columnname": "Capacity",
      "datatype": "String",
      "mappingkey": "capacity",
      "dropdown": "NO",
      "isdefault":  "false",
      "disabled": "false",
      "value": "",
      "maxlength": 1,
      "dropdowntype": "singleselect",
      "dropdownvalue": ""
    },
    {
      "display": "true",
      "ui_columnname": "Act Control Number",
      "db_columnname": "ActControlNumber",
      "datatype": "String",
      "mappingkey": "actControlNumber",
      "dropdown": "NO",
      "isdefault":  "false",
      "disabled": "false",
      "value": "",
      "maxlength": 20,
      "dropdowntype": "singleselect",
      "dropdownvalue": ""
    },
    {
      "display": "true",
      "ui_columnname": "Contra ControlNumber",
      "db_columnname": "ContraControlNumber",
      "datatype": "String",
      "mappingkey": "contraControlNumber",
      "dropdown": "NO",
      "isdefault":  "false",
      "disabled": "false",
      "value": "",
      "maxlength": 25,
      "dropdowntype": "singleselect",
      "dropdownvalue": ""
    },
    {
      "display": "true",
      "ui_columnname": "Bid Price",
      "db_columnname": "BidPrice",
      "datatype": "Float",
      "mappingkey": "nbbBidPrice",
      "dropdown": "NO",
      "isdefault":  "false",
      "disabled": "false",
      "value": "",
      "precision": 15,
      "scale": 6,
      "dropdowntype": "singleselect",
      "dropdownvalue": ""
    },
    {
      "display": "true",
      "ui_columnname": "Bid Size",
      "db_columnname": "BidSize",
      "datatype": "float",
      "mappingkey": "nbbBidSize",
      "dropdown": "NO",
      "isdefault":  "false",
      "disabled": "false",
      "value": "",
      "precision": 15,
      "scale": 6,
      "dropdowntype": "singleselect",
      "dropdownvalue": ""
    },
    {
      "display": "true",
      "ui_columnname": "Ask Price",
      "db_columnname": "AskPrice",
      "datatype": "Float",
      "mappingkey": "nbbAskPrice",
      "dropdown": "NO",
      "isdefault":  "false",
      "disabled": "false",
      "value": "",
      "precision": 15,
      "scale": 6,
      "dropdowntype": "singleselect",
      "dropdownvalue": ""
    },
    {
      "display": "true",
      "ui_columnname": "Ask Size",
      "db_columnname": "AskSize",
      "datatype": "float",
      "mappingkey": "nbbAskSize",
      "dropdown": "NO",
      "isdefault":  "false",
      "disabled": "false",
      "value": "",
      "precision": 15,
      "scale": 6,
      "dropdowntype": "singleselect",
      "dropdownvalue": ""
    },
    {
      "display": "true",
      "ui_columnname": "As Of",
      "db_columnname": "AsOf",
      "datatype": "String",
      "mappingkey": "asOf",
      "dropdown": "NO",
      "isdefault":  "false",
      "disabled": "false",
      "value": "",
      "maxlength": 1,
      "dropdowntype": "singleselect",
      "dropdownvalue": ""
    },
    {
      "display": "true",
      "ui_columnname": "Branch Seq Num",
      "db_columnname": "BranchSeqNum",
      "datatype": "String",
      "mappingkey": "branchSeqNum",
      "dropdown": "NO",
      "isdefault":  "false",
      "disabled": "false",
      "value": "",
      "maxlength": 40,
      "dropdowntype": "singleselect",
      "dropdownvalue": ""
    },
    {
      "display": "true",
      "ui_columnname": "Contra Branch Seq Num",
      "db_columnname": "ContraBranchSeqNumber",
      "datatype": "String",
      "mappingkey": "contraBranchSeqNumber",
      "dropdown": "NO",
      "isdefault":  "false",
      "disabled": "false",
      "value": "",
      "maxlength": 20,
      "dropdowntype": "singleselect",
      "dropdownvalue": ""
    },
    {
      "display": "true",
      "ui_columnname": "Clearing Broker MPID",
      "db_columnname": "ClearingBrokerMPID",
      "datatype": "String",
      "mappingkey": "clearingBrokerMpid",
      "dropdown": "NO",
      "isdefault":  "false",
      "disabled": "false",
      "value": "",
      "maxlength": 4,
      "dropdowntype": "singleselect",
      "dropdownvalue": ""
    },
    {
      "display": "true",
      "ui_columnname": "Clearing Num",
      "db_columnname": "ClearingNum",
      "datatype": "String",
      "mappingkey": "clearingNum",
      "dropdown": "NO",
      "isdefault":  "false",
      "disabled": "false",
      "value": "",
      "maxlength": 10,
      "dropdowntype": "singleselect",
      "dropdownvalue": ""
    },
    {
      "display": "true",
      "ui_columnname": "Ord.Entry Broker MPID",
      "db_columnname": "OrdEntryBrokerMPID",
      "datatype": "String",
      "mappingkey": "ordEntryBrokerMpid",
      "dropdown": "NO",
      "isdefault":  "false",
      "disabled": "false",
      "value": "",
      "maxlength": 4,
      "dropdowntype": "singleselect",
      "dropdownvalue": ""
    },
    {
      "display": "true",
      "ui_columnname": "Executing Broker MPID",
      "db_columnname": "ExecutingBrokerMPID",
      "datatype": "String",
      "mappingkey": "executingBrokerMpid",
      "dropdown": "NO",
      "isdefault":  "false",
      "disabled": "false",
      "value": "",
      "maxlength": 4,
      "dropdowntype": "singleselect",
      "dropdownvalue": ""
    },
    {
      "display": "true",
      "ui_columnname": "Ord Entry Giveup MPID",
      "db_columnname": "OrdEntryGiveupMPID",
      "datatype": "String",
      "mappingkey": "ordEntryGiveupMpid",
      "dropdown": "NO",
      "isdefault":  "false",
      "disabled": "false",
      "value": "",
      "maxlength": 4,
      "dropdowntype": "singleselect",
      "dropdownvalue": ""
    },
    {
      "display": "true",
      "ui_columnname": "Execution Giveup MPID",
      "db_columnname": "ExecutionGiveupMPID",
      "datatype": "String",
      "mappingkey": "executionGiveupMpid",
      "dropdown": "NO",
      "isdefault":  "false",
      "disabled": "false",
      "value": "",
      "maxlength": 4,
      "dropdowntype": "singleselect",
      "dropdownvalue": ""
    },
    {
      "display": "true",
      "ui_columnname": "Negotiated Trade",
      "db_columnname": "NegotiatedTrade",
      "datatype": "String",
      "mappingkey": "negotiatedTrade",
      "dropdown": "NO",
      "isdefault":  "false",
      "disabled": "false",
      "value": "",
      "maxlength": 30,
      "dropdowntype": "singleselect",
      "dropdownvalue": ""
    },
    {
      "display": "true",
      "ui_columnname": "Reporting Role",
      "db_columnname": "ReportingRole",
      "datatype": "String",
      "mappingkey": "reportingRole",
      "dropdown": "NO",
      "isdefault":  "false",
      "disabled": "false",
      "value": "",
      "maxlength": 1,
      "dropdowntype": "singleselect",
      "dropdownvalue": ""
    },
    {
      "display": "true",
      "ui_columnname": "PRP Date Time",
      "db_columnname": "PRPDateTime",
      "datatype": "String",
      "mappingkey": "prpDateTime",
      "dropdown": "NO",
      "isdefault":  "false",
      "disabled": "false",
      "value": "",
      "dropdowntype": "singleselect",
      "dropdownvalue": ""
    },
    {
      "display": "true",
      "ui_columnname": "TradeModifier 1",
      "db_columnname": "TradeModifier1",
      "datatype": "String",
      "mappingkey": "tradeModifier1",
      "dropdown": "NO",
      "isdefault":  "false",
      "disabled": "false",
      "value": "",
      "maxlength": 2,
      "dropdowntype": "singleselect",
      "dropdownvalue": ""
    },
    {
      "display": "true",
      "ui_columnname": "TradeModifier 2",
      "db_columnname": "TradeModifier2",
      "datatype": "String",
      "mappingkey": "tradeModifier2",
      "dropdown": "NO",
      "isdefault":  "false",
      "disabled": "false",
      "value": "",
      "maxlength": 2,
      "dropdowntype": "singleselect",
      "dropdownvalue": ""
    },
    {
      "display": "true",
      "ui_columnname": "TradeModifier 3",
      "db_columnname": "TradeModifier3",
      "datatype": "String",
      "mappingkey": "tradeModifier3",
      "dropdown": "NO",
      "isdefault":  "false",
      "disabled": "false",
      "value": "",
      "maxlength": 2,
      "dropdowntype": "singleselect",
      "dropdownvalue": ""
    },
    {
      "display": "true",
      "ui_columnname": "TradeModifier 4",
      "db_columnname": "TradeModifier4",
      "datatype": "String",
      "mappingkey": "tradeModifier4",
      "dropdown": "NO",
      "isdefault":  "false",
      "disabled": "false",
      "value": "",
      "maxlength": 2,
      "dropdowntype": "singleselect",
      "dropdownvalue": ""
    },
    {
      "display": "true",
      "ui_columnname": "TradeThruExemption(?)",
      "db_columnname": "TradeThroughExempt",
      "datatype": "String",
      "mappingkey": "tradeThroughExempt",
      "dropdown": "NO",
      "isdefault":  "false",
      "disabled": "false",
      "value": "",
      "maxlength": 30,
      "dropdowntype": "singleselect",
      "dropdownvalue": ""
    },
    {
      "display": "true",
      "ui_columnname": "ClearingFlag",
      "db_columnname": "ClearingFlag",
      "datatype": "String",
      "mappingkey": "clearingFlag",
      "dropdown": "NO",
      "isdefault":  "false",
      "disabled": "false",
      "value": "",
      "maxlength": 4,
      "dropdowntype": "singleselect",
      "dropdownvalue": ""
    },
    {
      "display": "true",
      "ui_columnname": "Report Status",
      "db_columnname": "ReportStatus",
      "datatype": "String",
      "mappingkey": "reportStatus",
      "dropdown": "NO",
      "isdefault":  "false",
      "disabled": "false",
      "value": "",
      "maxlength": 2,
      "dropdowntype": "singleselect",
      "dropdownvalue": ""
    },
    {
      "display": "true",
      "ui_columnname": "No Was Indicator",
      "db_columnname": "NoWasIndicator",
      "datatype": "String",
      "mappingkey": "noWasIndicator",
      "dropdown": "NO",
      "isdefault":  "false",
      "disabled": "false",
      "value": "",
      "maxlength": 1,
      "dropdowntype": "singleselect",
      "dropdownvalue": ""
    },
    {
      "display": "true",
      "ui_columnname": "Reject Reason",
      "db_columnname": "RejectReason",
      "datatype": "String",
      "mappingkey": "rejectReason",
      "dropdown": "NO",
      "isdefault":  "false",
      "disabled": "false",
      "value": "",
      "maxlength": 30,
      "dropdowntype": "singleselect",
      "dropdownvalue": ""
    },
    {
      "display": "true",
      "ui_columnname": "Break Indicator",
      "db_columnname": "BreakIndicator",
      "datatype": "String",
      "mappingkey": "breakIndicator",
      "dropdown": "NO",
      "isdefault":  "false",
      "disabled": "false",
      "value": "",
      "maxlength": 1,
      "dropdowntype": "singleselect",
      "dropdownvalue": ""
    },
    {
      "display": "true",
      "ui_columnname": "Related Market Center",
      "db_columnname": "RelatedMarketCenter",
      "datatype": "String",
      "mappingkey": "relatedMarketCenter",
      "dropdown": "NO",
      "isdefault":  "false",
      "disabled": "false",
      "value": "",
      "maxlength": 10,
      "dropdowntype": "singleselect",
      "dropdownvalue": ""
    },
    {
      "display": "true",
      "ui_columnname": "Trade Direction",
      "db_columnname": "TradeDirection",
      "datatype": "String",
      "mappingkey": "tradeDirection",
      "dropdown": "NO",
      "isdefault":  "false",
      "disabled": "false",
      "value": "",
      "maxlength": 1,
      "dropdowntype": "singleselect",
      "dropdownvalue": ""
    },
    {
      "display": "true",
      "ui_columnname": "Security Class",
      "db_columnname": "SecurityClass",
      "datatype": "String",
      "mappingkey": "securityClass",
      "dropdown": "NO",
      "isdefault":  "false",
      "disabled": "false",
      "value": "",
      "maxlength": 2,
      "dropdowntype": "singleselect",
      "dropdownvalue": ""
    },
    {
      "display": "true",
      "ui_columnname": "Special Trade",
      "db_columnname": "SpecialTrade",
      "datatype": "String",
      "mappingkey": "specialTrade",
      "dropdown": "NO",
      "isdefault":  "false",
      "disabled": "false",
      "value": "",
      "maxlength": 1,
      "dropdowntype": "singleselect",
      "dropdownvalue": ""
    },
    {
      "display": "true",
      "ui_columnname": "Publish Indicator",
      "db_columnname": "PublishIndicator",
      "datatype": "String",
      "mappingkey": "publishIndicator",
      "dropdown": "NO",
      "isdefault":  "false",
      "disabled": "false",
      "value": "",
      "maxlength": 1,
      "dropdowntype": "singleselect",
      "dropdownvalue": ""
    },
    {
      "display": "true",
      "ui_columnname": "Reporting Aggrement",
      "db_columnname": "ReportingAggrement",
      "datatype": "String",
      "mappingkey": "reportingAggrement",
      "dropdown": "NO",
      "isdefault":  "false",
      "disabled": "false",
      "value": "",
      "maxlength": 1,
      "dropdowntype": "singleselect",
      "dropdownvalue": ""
    },
    {
      "display": "true",
      "ui_columnname": "Override",
      "db_columnname": "Override",
      "datatype": "String",
      "mappingkey": "override",
      "dropdown": "NO",
      "isdefault":  "false",
      "disabled": "false",
      "value": "",
      "maxlength": 1,
      "dropdowntype": "singleselect",
      "dropdownvalue": ""
    },
    {
      "display": "true",
      "ui_columnname": "Short Sale Exemption",
      "db_columnname": "ShortSaleExemption",
      "datatype": "String",
      "mappingkey": "shortSaleExemption",
      "dropdown": "NO",
      "isdefault":  "false",
      "disabled": "false",
      "value": "",
      "maxlength": 1,
      "dropdowntype": "singleselect",
      "dropdownvalue": ""
    }
  ]
}
